import React from 'react';

export function NumberQuestion({ question, value, onChange }) {
  return (
    <input
      type="number"
      min={question.min}
      max={question.max}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Digite sua idade"
      className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition text-gray-700"
    />
  );
}
